module.exports = __webpack_public_path__ + "img/blueBell.3a52165a.svg";